import React from 'react'
import { testId } from '@lojinha/helpers'
import { Table } from '../../../components/table'
import { t } from '../../../dictionary'
import { NutritionFact } from '../../page-content/page-content.types'

type Props = {
  nutritionFacts: NutritionFact
}

export const NutritionTable = ({ nutritionFacts }: Props) => {
  const { facts, portionSize, portionUnit } = nutritionFacts

  const tableName = t.nutritionTablePortion({
    size: portionSize,
    unit: portionUnit,
  })

  const columns = [tableName, ...t.nutritionTable.columns]
  const rows = facts.map(item => {
    const { label, value, unit, dailyValuePercentage } = item

    return {
      label: label,
      value: `${value} ${unit}`,
      dailyValuePercent: dailyValuePercentage
        ? `${dailyValuePercentage}%`
        : `**%`,
    }
  })

  return (
    <Table
      cols={columns}
      data={rows}
      caption={t.nutritionTable.caption}
      footer={t.nutritionTable.info}
      footerHighlight={t.nutritionTable.infoHighlight}
      {...testId('marketable-product-nutrition-table')}
    />
  )
}
